<template>
  <LoadOnVisible v-on:intersected="loadChartData">
    <b-card no-body v-if="items && items.length">
      <b-card-header>
        <!-- title and subtitle -->
        <div>
          <b-card-title class="mb-1" title-tag="h5">
            Purchase Orders To Review
          </b-card-title>
        </div>

        <span
          class="border badge badge-transparent d-none d-sm-inline-block"
          right
          no-caret
          toggle-class="p-0 mb-25"
          size="sm"
          >these have gone past expected date and had no activity in a while
        </span>
        <!-- datepicker -->
      </b-card-header>

      <b-card-body class="p-0">
        <div class="text-center" v-if="isLoadingChartData">
          <b-spinner
            variant="primary"
            class="m-5"
            style="height: 4rem; width: 4rem"
            label="Loading..."
          ></b-spinner>
        </div>
        <div v-else>
          <TableListing
            class="mt-0"
            moreCustom5Class="nopadinr"
            sticky-header
            :responsive="true"
            :fixed="false"
            head-variant="light"
            :hide-pagination-top-fields="true"
            :loading-page="isLoadingChartData"
            :items.sync="items"
            :showPaginationRow="false"
            :fields.sync="tableColumns"
            :bordered="false"
          >
              <template v-slot:cell(user)="data">
                <div>
                  <span  class="d-inline-block mr-1">
                    <label v-if="data.item.customerRequested" class="badge badge-danger m-0" v-b-tooltip.hover title="Entered By Customerr/Third Party"><i class="fa fa-user"></i></label>
                    <label v-else class="badge badge-warning m-0" v-b-tooltip.hover title="Entered By Logistics/Manufacturer"><i class="fa fa-users"></i></label>
                  </span>
                  <span
                  v-if="
                    data.item.byUserInfo && data.item.byUserInfo.fullName"
                  >{{ data.item.byUserInfo.fullName }} </span
                >
                <span v-else> Unknown </span>
                </div>
              </template>
              <template v-slot:cell(createDateTimeUtc)="data">
                <span
                  v-if="
                    data.item.createDateTimeUtc &&
                      !data.item.createDateTimeUtc.endsWith('Z')
                  "
                  >{{
                    (data.item.createDateTimeUtc + 'Z')
                      | moment('MMM Do YY, h:mm a')
                  }}</span
                >
                <span v-else-if="data.item.createDateTimeUtc">{{
                  data.item.createDateTimeUtc | moment('MMM Do YY, h:mm a')
                }}</span>
              </template>

              <template v-slot:cell(vendorId)="data">
                <span
                  v-if="myVendors && myVendors.find(a => a.id == data.item.vendorId)"
                  >{{ myVendors.find(a => a.id == data.item.vendorId).name }}</span
                >
                <span v-else>-</span>
              </template>
              <template v-slot:cell(brandId)="data">
                <span
                  v-if="myBrands && myBrands.find(a => a.id == data.item.brandId)"
                  >{{ myBrands.find(a => a.id == data.item.brandId).name }}</span
                >
                <span v-else>N / A</span>
              </template>

              <template v-slot:cell(expectedDate)="data">
                <span>{{ data.item.expectedDate | moment('MMMM Do YYYY') }}</span>
              </template>

              <template v-slot:cell(orderStatus)="data">
                <div :id="'ht' + data.item.id">
                  <template v-if="data.item.forceStatus">
                    <label class="badge badge-warning"
                      ><i class="fa fa-check" /> {{ data.item.forceStatus }}</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 0">
                    <label class="badge badge-info"
                      ><i class="fa fa-check" /> Open</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 1">
                    <label class="badge badge-secondary"
                      ><i class="fa fa-check" /> Request (Pending)</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 2">
                    <label class="badge badge-warning"
                      ><i class="fa fa-check" /> Active</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 4">
                    <label class="badge badge-danger"
                      ><i class="fa fa-check" /> Cancelled</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 5">
                    <label class="badge badge-warning"
                      ><i class="fa fa-check" /> Active</label
                    >
                  </template>
                  <template v-else-if="data.item.orderStatus == 6">
                    <label class="badge badge-warning"
                      ><i class="fa fa-check" /> Active</label
                    >
                  </template>
                  <template v-else>
                    <label class="badge badge-success badge-green"
                      ><i class="fa fa-check" /> Completed</label
                    >
                  </template>
                </div>
                <b-popover
                  container="body"
                  boundary="viewport"
                  v-if="data.item.shippings.length > 0"
                  class="popovermappings"
                  :target="'ht' + data.item.id"
                  triggers="hover"
                  placement="right"
                >
                  <template v-slot:title>
                    Shipments:
                  </template>
                  <b-list-group>
                    <b-list-group-item
                      v-for="shipPO in data.item.shippings"
                      :key="shipPO.id"
                      class="p-1"
                    >
                      <div>
                        <span class="badge badge-secondary">{{ shipPO.name }}</span>
                        <span>
                          - Status:
                          <template v-if="shipPO.realStatus == 'Open'">
                            <label class="badge badge-info"
                              ><i class="fa fa-check" /> Open</label
                            >
                          </template>
                          <template v-else-if="shipPO.realStatus == 'On Hold'">
                            <label class="badge badge-secondary"
                              ><i class="fa fa-check" /> On Hold</label
                            >
                          </template>
                          <template v-else-if="shipPO.realStatus == 'Complete'">
                            <label class="badge badge-success badge-green"
                              ><i class="fa fa-check" /> Complete</label
                            >
                          </template>
                          <template v-else>
                            <label class="badge badge-warning"
                              ><i class="fa fa-check" />
                              {{
                                shipPO.realStatus ? shipPO.realStatus : 'Unknown'
                              }}</label
                            >
                          </template>
                        </span>
                      </div>
                    </b-list-group-item>
                  </b-list-group>
                </b-popover>
              </template>

              <template v-slot:cell(id)="data">
                <router-link
                  class="btn btn-info ml-1"
                  target="_blank"
                  :to="{name: 'Warehouses.PurchaseOrders.View', params: { id: data.item.id } }"
                >
                  View
                </router-link>

                <div
                  v-if="data.item.orderStatus != 3 && data.item.orderStatus != 4"
                  class="d-inline-block"
                >
                  <b-dropdown
                    id="dropdown-right"
                    right
                    text="More"
                    variant="primary"
                    boundary="viewport"
                    class="mx-2"
                  >
                    <b-dropdown-item
                      class="icon-dropitem"
                      @click="MarkAsReviewed(data.item)"
                    >
                      <i class="fa fa-hourglass-o mr-2 text-success" />
                      <span class="text-secondary">Mark As Reviewed</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="icon-dropitem"
                      @click="MarkAs('completed', data.item)"
                    >
                      <i class="fa fa-check-circle-o mr-2 text-success" />
                      <span class="text-success">Mark as Complete</span>
                    </b-dropdown-item>
                    <b-dropdown-item
                      class="icon-dropitem"
                      @click="MarkAs('cancelled', data.item)"
                    >
                      <i class="fa fa-times-circle-o mr-2 text-danger" />
                      <span class="text-danger">Mark as Cancelled</span>
                    </b-dropdown-item>
                  </b-dropdown>
                </div>

              </template>
          </TableListing>
        </div>
      </b-card-body>
    </b-card>
  </LoadOnVisible>
</template>

<script>
import { myCommonDataMixin } from '@/helpers/utils/vueMixins.js';
import { TableListing, LoadOnVisible } from '@/views/components/custom';
export default {
  mixins: [myCommonDataMixin],
  components: {
    TableListing: TableListing,
    LoadOnVisible
  },
  data() {
    return {
      tableOpts: {
        totalRows: 0,
        loadedAll: true
      },
      items: [],
      tableColumns: [
      { key: 'orderNumber', label: 'Order #', sortable: false },
      { key: 'brandId', label: 'Client', sortable: false },
      //{ key: 'vendorId', label: 'Vendor', sortable: false },
      { key: 'orderStatus', label: 'Status', sortable: false },
      { key: 'expectedDate', label: 'Expected', sortable: false },
      //{ key: 'user', label: 'By User', sortable: false },
      //{ key: 'createDateTimeUtc', label: 'Created At', sortable: false },
      { key: 'id', label: 'Action', sortable: false }
      ],
      isLoadingChartData: true
    };
  },
  created() {
    // subcomponent, do not call common data
  },
  computed: {
  },
  methods: {
    MarkAs(what, item) {
      this.$swal({
        title: 'Are you sure you want to close this?',
        text: "You won't be able to revert this!",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, mark it as closed!'
      }).then(result => {
        if (result.value) {
          if (what == 'completed') {
            item.orderStatus = 3;
          } else if (what == 'cancelled') {
            item.orderStatus = 4;
          }
          this.$http
            .post('/api/common/purchaseOrders/markAs/'+ item.id + '/' + item.orderStatus)
            .then(resp => {
                this.loadChartData();
                this.$swal('Done!', 'Order change saved.', 'success');
            })
            .catch(err => {});
        }
      });
    },
    MarkAsReviewed(item) {
      this.$swal({
        title: 'Are you sure you want to mark as reviewed?',
        text: "This will leave the PO as is, for another week, should it still be open after that you will be requested to review it again.",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, mark as reviewed!'
      }).then(result => {
        if (result.value) {
          this.$http
            .post('/api/common/purchaseOrders/reviewed/'+ item.id)
            .then(resp => {
              if(resp.data.success) {
                this.loadChartData();
                this.$swal('Done!', 'PO marked as reviewed.', 'success');
              } else {
                this.$swal({ title: 'Error!', text: resp.data.errorMessage, icon: 'error' });
              }
            })
            .catch(err => {});
        }
      });
    },
    loadChartData() {
      this.isLoadingChartData = true;
      this.$http
        .post('/api/common/purchaseOrders/should-be-reviewed', {})
        .then(resp => {
          this.isLoadingChartData = false;
          this.items = resp.data;
          this.tableOpts.totalRows = this.items.length;
        })
        .catch(err => {
          this.isLoadingChartData = false;
          this.items = [];
        });
    }
  },
  mounted() {
  }
};
</script>
